/**
 * @generated SignedSource<<27400355908b3ee6a6d50a02e8315d7f>>
 * @relayHash 22cf7db5c98b68e8d7c2fbf3b41ad8d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e082a0561273aba859d979843fbf1e23fe97052a2abce6b5d739801d69313584

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentBlogUnifiedQuery$variables = {
  contentId: string;
  includeAgentTrustReceiptData?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey?: string | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentBlogUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly contentProperties?: {
        readonly latest: {
          readonly generatedBy: string | null;
        } | null;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations?: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly confRev: string | null;
        readonly number: number | null;
        readonly when?: string | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageStatusQueryRelaySpike_content">;
    } | null> | null;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space">;
  } | null;
};
export type ContentBlogUnifiedQuery = {
  response: ContentBlogUnifiedQuery$data;
  variables: ContentBlogUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "status"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "subType"
},
v12 = {
  "kind": "ScalarField",
  "name": "title"
},
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "number"
},
v16 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confRev"
    },
    (v15/*: any*/),
    {
      "condition": "includeAgentTrustReceiptData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "when"
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ]
},
v22 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ]
  }
],
v23 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v24 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v25 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "representation"
},
v27 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v28 = [
  (v27/*: any*/)
],
v29 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v26/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v28/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v30 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v20/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v8/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v28/*: any*/)
            },
            (v27/*: any*/)
          ]
        }
      ]
    }
  ]
},
v31 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v32 = {
  "kind": "ScalarField",
  "name": "name"
},
v33 = {
  "condition": "preloadLabels",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASCENDING",
            "sortField": "LABELLING_CREATIONDATE"
          }
        }
      ],
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v8/*: any*/),
            {
              "kind": "ScalarField",
              "name": "label"
            },
            (v32/*: any*/),
            {
              "kind": "ScalarField",
              "name": "prefix"
            }
          ]
        }
      ],
      "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ]
},
v34 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v35 = {
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "kind": "ScalarField",
      "name": "themeKey"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "background"
},
v37 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v38 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v39 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v40 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v41 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v42 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v43 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v44 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v45 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v46 = {
  "concreteType": "LookAndFeel",
  "kind": "LinkedField",
  "name": "lookAndFeel",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentLookAndFeel",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "concreteType": "ScreenLookAndFeel",
          "kind": "LinkedField",
          "name": "screen",
          "plural": false,
          "selections": [
            (v36/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/),
            (v39/*: any*/),
            (v40/*: any*/),
            (v41/*: any*/),
            (v42/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v45/*: any*/),
            {
              "concreteType": "LayerScreenLookAndFeel",
              "kind": "LinkedField",
              "name": "layer",
              "plural": false,
              "selections": [
                (v36/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v42/*: any*/),
                (v43/*: any*/),
                (v44/*: any*/),
                (v45/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "width"
                },
                {
                  "kind": "ScalarField",
                  "name": "height"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "gutterTop"
            },
            {
              "kind": "ScalarField",
              "name": "gutterRight"
            },
            {
              "kind": "ScalarField",
              "name": "gutterBottom"
            },
            {
              "kind": "ScalarField",
              "name": "gutterLeft"
            }
          ]
        },
        {
          "concreteType": "ContainerLookAndFeel",
          "kind": "LinkedField",
          "name": "container",
          "plural": false,
          "selections": [
            (v36/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/),
            (v39/*: any*/),
            (v40/*: any*/),
            (v41/*: any*/),
            (v42/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v45/*: any*/),
            {
              "kind": "ScalarField",
              "name": "padding"
            },
            {
              "kind": "ScalarField",
              "name": "borderRadius"
            }
          ]
        }
      ]
    }
  ]
},
v47 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v48 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v16/*: any*/),
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v19/*: any*/)
                ]
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v33/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          (v8/*: any*/),
          (v35/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v16/*: any*/),
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v18/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v19/*: any*/)
                ]
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v33/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          (v46/*: any*/),
          (v8/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "22cf7db5c98b68e8d7c2fbf3b41ad8d6",
    "id": "e082a0561273aba859d979843fbf1e23fe97052a2abce6b5d739801d69313584",
    "metadata": {},
    "name": "ContentBlogUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentBlogUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$includeAgentTrustReceiptData:Boolean=false){content(id:$contentId,version:$versionOverride){nodes{...PageStatusQueryRelaySpike_content,id,status,type,subType,title,space{id,key,alias},version{confRev,number,when@include(if:$includeAgentTrustReceiptData)},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},body{dynamic{representation,value,content{version{number},id},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}}\n      operations@include(if:$preloadLabels){operation,targetType}}},space(key:$spaceKey){...ContentContainerTheme_space,id,theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment PageStatusQueryRelaySpike_content on Content{status}"
  }
};
})();

(node as any).hash = "ca173a918c17a7fb52e8c7e325590f49";

export default node;
